











import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { AuthStateInterface } from 'modules/auth/interfaces/authState';
import { UserInterface } from 'modules/auth/interfaces/user';
import { SubscriptionStatus } from 'modules/auth/enums/subscriptionStatus';

@Component({
  name: 'subscription-alert',
})
export default class SubscriptionAlert extends Vue {
  @State('auth') private auth!: AuthStateInterface;

  get shouldDisplayAlert() {
    if (this.auth && this.auth.user) {
      if (this.auth.user.subscriptionStatus === SubscriptionStatus.SUB_ENDED ||
      this.auth.user.subscriptionStatus === SubscriptionStatus.SUB_NEAR_END) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  public getSubscriptionStatus() {
    if (this.auth && this.auth.user && this.auth.user.subscriptionStatus) {
      return this.auth.user.subscriptionStatus;
    }
  }

  get isSubscriptionNearEnd() {
    if (this.getSubscriptionStatus() === SubscriptionStatus.SUB_NEAR_END) {
      return true;
    } else {
      return false;
    }
  }

  get isSubscriptionEnded() {
    if (this.getSubscriptionStatus() === SubscriptionStatus.SUB_ENDED) {
      return true;
    } else {
      return false;
    }
  }
}
